//
//
//
//
//
//
//
//
//
export default {
  name: "RouteView",
  computed: {
    keepAlive: function keepAlive() {
      return this.$route.meta.keepAlive;
    }
  }
};